











































































































































































































import FeedbackComponent from '@/components/base/FeedbackComponent'
import {CRMFileType} from "@/components/dashboard/customer-service/components/CreateNewCustomerServiceCRMContact.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {KeyValuePair} from '@payroll/optimus-common'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({})
export default class SendNotification extends FeedbackComponent {

  @Prop(String) name: string = ""
  @Prop(String) idNum: string = ""
  @Prop(String) crmId: string = ""
  @Prop(Object) subjectOfArrival: KeyValuePair = {value: "", description: ""}
  @Prop(String) email: string = ""
  @Prop(String) emailToReplay: string = ""
  @Prop(Boolean) sendNotificationFlag: boolean = false
  @Prop(Boolean) isMember: boolean = false
  @Prop(Boolean) isDeath: boolean = false


  @Action('getConfigCRMDetails', StoreNamespace.CUSTOMER_SERVICE) getConfigCRMDetails: any;
  @Action('sendNotification', StoreNamespace.CUSTOMER_SERVICE) sendNotification: any;
  @Action('managingCompanyCRMName', StoreNamespace.CUSTOMER_SERVICE) getManagingCompanyCRMName: any;


  private emailsForDistribution: string[] = [""]

  private notificationContactToSend: string = ""
  private companyName: string = ""
  private updatedEmail: string | null = ""
  private attachmentFileOne: File[] = [];
  private attachmentFileTwo: File[] = [];
  private attachmentFileThree: File[] = [];
  private attachmentFileFour: File[] = [];
  private attachmentFileFive: File[] = [];
  private attachmentsMap = new Map<number, any>();
  private smsValue: boolean = false
  private emailValue: boolean = false
  private showMailingOptions: boolean = false

  mounted() {
    this.getManagingCompanyCRMName({
      requestorCallback: this
    })

    this.getConfigCRMDetails({
      requestorCallback: this
    })
  }

  public getEmailAddress() {
    let result = this.email

    if (!this.email) {
      return result;
    }

    const re = /^[a-z0-9][a-z0-9\-_\.]+@[a-z0-9\-]+(\.[a-z0-9\-]+){0,3}(\.[a-z]{2,10})$/i;

    if (!re.test(this.email.toLowerCase())) {
      result = '';
    }

    return result;
  }

  @Watch('email')
  onEmailUpdated() {
    if (this.email) {
      this.emailsForDistribution[0] = this.email;
    }
  }

  @Watch('sendNotificationFlag')
  onSendNotification() {
    if (this.sendNotificationFlag) {
      this.sendNotificationToCustomer()
    }
  }

  onSuccess(data: any, requestName?: string, message?: string): void {
    switch (requestName) {
      case 'managingCompanyCRMName':
        this.companyName = data
        break;
      case 'crmConfigurationManagement/getConfigCRMDetails':
        this.smsValue = data.sendSmsFlag
        this.emailValue = !data.sendSmsFlag
        this.showMailingOptions = data.sendSmsFlag
        break;
    }
  }

  onError(messages: string[], code: number, requestName?: string): void {

    switch (requestName) {
      case 'sendNotification':

        let message = "נוצרה שגיאה בניסיון שליחת עדכון";
        message = this.isMember ? message + " לעמית" : message + " למעסיק"

        this.showErrorPopupMessage(message);
        break;

      default:
        this.handleOnError(messages, code, requestName);
    }
  }

  private showErrorPopupMessage(message: string) {
    console.log("show error popup")
    this.$root.$emit('showErrorAlertNotification', {
      toShow: true,
      message: message,
      icon: 'warning',
      secondsToDisappear: 10
    })
  }

  get notificationToSendAsMemberWillSee(): string {
    let isDeathText = this.name;

    if (this.isDeath) {
      isDeathText = "יורש / מוטב של " + this.name

      if (!(isDeathText.includes("ז''ל") || isDeathText.includes('ז"ל'))) {
        isDeathText = isDeathText + " ז''ל"
      }
    }

    return `שלום ${isDeathText},
            <br>
            בנוגע לפנייתך בנושא
             ${this.subjectOfArrival.description}.
            <br>
            ${this.notificationContactToSend ? this.notificationContactToSend.replace(/\n/g, '<br>') : "{ **תוכן ההודעה** }"}
            <br>
            לבירורים בנוגע לפנייה זו ניתן לפנות:
            <br>
            ${this.emailToReplay}
            <br>
            בברכה,
            <br>
            ${this.companyName}
`
  }

  onInputFile(files: any[], fileType: CRMFileType) {
    this.changeMailingTypeAfterAddingAttachments()
    if (files.length === 0) {
      return
    }

    this.attachmentsMap.set(fileType, files[0]);
  }

  private onRemovedAttachmentClicked(fileType: CRMFileType) {
    switch (fileType) {
      case CRMFileType.FILE_ONE:
        this.attachmentFileOne = [];
        this.attachmentsMap.delete(fileType)
        break;
      case CRMFileType.FILE_TWO:
        this.attachmentFileTwo = [];
        this.attachmentsMap.delete(fileType)
        break;
      case CRMFileType.FILE_THREE:
        this.attachmentFileThree = [];
        this.attachmentsMap.delete(fileType)
        break;
      case CRMFileType.FILE_FOUR:
        this.attachmentFileFour = [];
        this.attachmentsMap.delete(fileType)
        break;
      case CRMFileType.FILE_FIVE:
        this.attachmentFileFive = [];
        this.attachmentsMap.delete(fileType)
        break;
    }


    if (this.attachmentsMap.size == 0) {
      this.showMailingOptions = false
      this.getConfigCRMDetails({
        requestorCallback: this
      })
    }

  }

  private sendNotificationToCustomer() {

    const formData: FormData = new FormData();

    if (this.attachmentsMap.size > 0) {

      this.attachmentsMap.forEach((value, key) => {
        formData.append('files', value.file);
      });
    }

    this.emailsForDistribution.forEach((email) => {
      formData.append('email', email + "")
    });


    const contact = this.notificationContactToSend ? this.notificationContactToSend + "" : ""

    formData.append('subjectOfArrivalId', this.subjectOfArrival.value + "")
    formData.append('idNum', this.idNum + "")
    formData.append('notificationContactToSend', contact)
    formData.append('isMember', this.isMember + "")
    formData.append('crmId', this.crmId)
    formData.append('sendSmsFlag', this.smsValue + "")
    formData.append('sendEmailFlag', this.emailValue + "")

    this.sendNotification({
      requestorCallback: this,
      requestBody: formData
    });
  }

  private handleEmailInput(index: number) {
    if (this.emailsForDistribution[index] == null) {
      this.emailsForDistribution[index] = ""
    }
  }


  changeMailingTypeAfterAddingAttachments() {
    this.showMailingOptions = false

    setTimeout(() => {
      this.showMailingOptions = this.smsValue
      this.smsValue = false
      this.emailValue = true
    }, 1);
  }

  addEmailField() {
    this.emailsForDistribution.push(''); // Add a new empty email field
  }

  removeEmailField() {
    this.emailsForDistribution.pop()
  }
}

